import React from "react";
import { FormControl, Text } from "@chakra-ui/react";
import { VStack } from "@chakra-ui/layout";
import { Controller, useFormContext } from "react-hook-form";
import { PercentageInput } from "components/PercentageInput";

interface PercentageAddressCellProps {
  id: string;
  title?: string;
  max?: number;
  min?: number;
  isInvalid?: boolean;
}

export const PercentageAddressCell: React.FC<PercentageAddressCellProps> = ({
  id,
  title = "",
  max = 100,
  min = 0,
  isInvalid,
}) => {
  const { control } = useFormContext();

  return (
    <FormControl id={id} pos="relative" width="30%">
      <VStack alignItems="flex-start">
        <Text fontSize={14} fontWeight={600} color="whiteAlpha.500">
          {title.toUpperCase()}
        </Text>
        <Controller
          control={control}
          defaultValue={10}
          name={id}
          render={({ field: { ref, ...restField } }) => (
            <PercentageInput
              isInvalid={isInvalid}
              {...restField}
              max={max}
              min={min}
              onBlur={() => {
                restField.onBlur();
              }}
              ref={ref}
            />
          )}
        />
      </VStack>
    </FormControl>
  );
};
